module.exports = __webpack_public_path__ + "img/kraftHeinz.bc6bb68b.png";